import { CloudAlert } from 'lucide-react';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  title?: string;
  subtitle?: string;
  showBorder?: boolean;
  children?: ReactNode[];
}

export function EmptyState({
  title = 'No data found',
  subtitle = "You haven't created any record yet. Get started by creating your first record.",
  showBorder = true,
  ...props
}: EmptyStateProps) {
  return (
    <Empty className={showBorder ? 'rounded-2xl' : 'border-0'}>
      <EmptyHeader>
        <EmptyMedia variant='icon'>
          <CloudAlert />
        </EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{subtitle}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>{props.children}</EmptyContent>
    </Empty>
  );
}
